import React from 'react';
import { useTranslation } from 'react-i18next';
// import { motion } from 'framer-motion'; // Removed for static content
import { 
  MapPin, 
  Clock, 
  Phone, 
  CreditCard, 
  Car, 
  Users, 
  Info,
  Accessibility,
  CheckCircle
} from 'lucide-react';

const FindUs = () => {
  const { t } = useTranslation();

  const hours = [
    { day: 'monday', hours: t('findUs.hours.monday') },
    { day: 'tuesday', hours: t('findUs.hours.tuesday') },
    { day: 'wednesday', hours: t('findUs.hours.wednesday') },
    { day: 'thursday', hours: t('findUs.hours.thursday') },
    { day: 'friday', hours: t('findUs.hours.friday') },
    { day: 'saturday', hours: t('findUs.hours.saturday') },
    { day: 'sunday', hours: t('findUs.hours.sunday') }
  ];

  const infoItems = [
    { icon: CheckCircle, text: t('findUs.info.noReservation'), color: '#4caf50' },
    { icon: Users, text: t('findUs.info.birthday'), color: '#ff9800' },
    { icon: CreditCard, text: t('findUs.info.payment'), color: '#2196f3' },
    { icon: Info, text: t('findUs.info.halal'), color: '#9c27b0' },
    { icon: Clock, text: t('findUs.info.open'), color: '#f44336' },
    { icon: Phone, text: t('findUs.info.phone'), color: '#00bcd4' }
  ];

  return (
    <div className="find-us">
      <section 
        className="find-us-hero section"
      >
        <div className="find-us-header">
          <MapPin className="header-icon" />
          <h1>{t('findUs.title')}</h1>
          <p>{t('findUs.subtitle')}</p>
        </div>
      </section>

      {/* Location Section */}
      <section 
        className="location-section section"
      >
        <div className="location-content">
          <div className="location-info glass-card">
            <div className="location-header">
              <MapPin className="section-icon" />
              <h2>{t('findUs.addressTitle')}</h2>
            </div>
            <div className="address-details">
              <h3>{t('findUs.address')}</h3>
              <p>{t('findUs.location')}</p>
              <p className="location-detail">{t('findUs.locationDetail')}</p>
              
              <a 
                href="https://www.google.com/maps/search/?api=1&query=1+rue+André+Citroën+78140+Vélizy-Villacoublay"
                target="_blank"
                rel="noopener noreferrer"
                className="ocean-btn google-maps-btn"
              >
                <MapPin size={20} />
                {t('findUs.googleMaps')}
              </a>
            </div>
          </div>
          
          <div className="map-placeholder glass-card">
            <iframe
              title="Pacific 91 Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2637.5555555!2d2.3653!3d48.6253!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47e5df81bcac8def%3A0x8fac3e40b5a7bdbc!2s37%20Av.%20de%20l&#39;Hurepoix%2C%2091700%20Fleury-M%C3%A9rogis%2C%20France!5e0!3m2!1sen!2sfr!4v1234567890!5m2!1sen!2sfr"
              width="100%"
              height="300"
              style={{ border: 0, borderRadius: '15px' }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
          
          <div className="street-view-section glass-card" style={{ marginTop: '2rem' }}>
            <h3 style={{ marginBottom: '1rem', color: '#90e0ef' }}>{t('findUs.streetView') || 'Vue intérieure du restaurant'}</h3>
            <iframe
              title="Pacific 91 Street View"
              src="https://www.google.com/maps/embed?pb=!3m2!2sen!2sfr!4v1234567890!6m8!1m7!1sCAoSHENJQUJJaEFHYnlmUXZoVDRJR2Zka0p3QUN1c1o%3D!2m2!1d48.62532!2d2.365325!3f105.33308!4f9.995005!5f0.7820865974627469"
              width="100%"
              height="400"
              style={{ border: 0, borderRadius: '15px' }}
              allowFullScreen=""
              loading="lazy"
            ></iframe>
          </div>
        </div>
      </section>

      {/* Hours Section */}
      <section 
        className="hours-section section"
      >
        <div className="hours-content glass-card">
          <div className="hours-header">
            <Clock className="section-icon" />
            <h2>{t('findUs.hours.title')}</h2>
          </div>
          <div className="hours-grid">
            {hours.map((item) => (
              <div 
                key={item.day}
                className="hour-item"
              >
                <div className="day-name">
                  {item.hours.split(' ')[0]}
                </div>
                <div className="hour-times">
                  {item.hours.split(' ').slice(1).join(' ')}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Info Section */}
      <section 
        className="info-section section"
      >
        <h2>{t('findUs.info.title')}</h2>
        <div className="info-grid">
          {infoItems.map((item, index) => (
            <div 
              key={index}
              className="info-item glass-card"
            >
              <item.icon 
                className="info-icon" 
                style={{ color: item.color }}
              />
              <p>{item.text}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Accessibility Section */}
      <section 
        className="accessibility-section section"
      >
        <div className="accessibility-content">
          <div className="accessibility-info glass-card">
            <div className="accessibility-header">
              <Accessibility className="section-icon" />
              <h2>{t('findUs.accessibility.title')}</h2>
            </div>
            <div className="accessibility-items">
              <div className="accessibility-item">
                <Accessibility className="accessibility-icon" />
                <span>{t('findUs.accessibility.pmr')}</span>
              </div>
              <div className="accessibility-item">
                <Car className="accessibility-icon" />
                <span>{t('findUs.accessibility.parking')}</span>
              </div>
            </div>
          </div>

        </div>
      </section>

      <style jsx>{`
        .find-us {
          min-height: 100vh;
        }

        .find-us-header {
          text-align: center;
          margin-bottom: 3rem;
        }

        .header-icon {
          color: #64b5f6;
          width: 4rem;
          height: 4rem;
          margin: 0 auto 1rem;
        }

        .find-us-header h1 {
          font-size: 3rem;
          margin-bottom: 1rem;
        }

        .find-us-header p {
          font-size: 1.2rem;
          color: rgba(255, 255, 255, 0.8);
        }

        .location-content {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 3rem;
          align-items: start;
        }

        .location-header,
        .hours-header,
        .accessibility-header,
        .social-header {
          display: flex;
          align-items: center;
          gap: 1rem;
          margin-bottom: 2rem;
        }

        .section-icon {
          color: #64b5f6;
          width: 2.5rem;
          height: 2.5rem;
          margin-bottom: 0;
        }

        .address-details h3 {
          color: #64b5f6;
          font-size: 1.3rem;
          margin-bottom: 1rem;
        }

        .location-detail {
          color: rgba(255, 255, 255, 0.7);
          font-style: italic;
          margin-bottom: 2rem;
        }

        .google-maps-btn {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          margin-top: 1rem;
        }

        .hours-grid {
          display: grid;
          gap: 1rem;
        }

        .hour-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 1rem;
          background: rgba(255, 255, 255, 0.05);
          border-radius: 10px;
          border-left: 3px solid #64b5f6;
        }

        .day-name {
          font-weight: 600;
          color: #64b5f6;
          min-width: 80px;
        }

        .hour-times {
          color: rgba(255, 255, 255, 0.9);
          font-family: monospace;
        }

        .info-section h2 {
          text-align: center;
          font-size: 2.5rem;
          margin-bottom: 3rem;
          color: #64b5f6;
          font-family: 'Playfair Display', serif;
        }

        .info-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
          gap: 1.5rem;
          max-width: 1200px;
          margin: 0 auto;
        }

        .info-item {
          display: flex;
          align-items: center;
          gap: 1rem;
          padding: 1.5rem;
          background: rgba(255, 255, 255, 0.05);
          transition: all 0.3s ease;
          text-align: left;
        }

        .info-icon {
          width: 2rem;
          height: 2rem;
          flex-shrink: 0;
        }

        .info-item p {
          margin: 0;
          color: rgba(255, 255, 255, 0.9);
          line-height: 1.5;
          text-align: left;
          flex: 1;
        }

        .accessibility-content {
          display: flex;
          justify-content: center;
        }

        .accessibility-items {
          display: flex;
          flex-direction: column;
          gap: 1.5rem;
        }

        .accessibility-item {
          display: flex;
          align-items: center;
          gap: 1rem;
          padding: 1rem;
          background: rgba(255, 255, 255, 0.05);
          border-radius: 10px;
          border-left: 3px solid #4caf50;
        }

        .accessibility-icon {
          color: #4caf50;
          width: 1.5rem;
          height: 1.5rem;
        }


        @media (max-width: 768px) {
          .find-us-header h1 {
            font-size: 2.5rem;
          }

          .location-content {
            grid-template-columns: 1fr;
            gap: 2rem;
          }

          .info-grid {
            grid-template-columns: 1fr;
          }

          .hour-item {
            flex-direction: column;
            align-items: flex-start;
            gap: 0.5rem;
          }

          .location-header,
          .hours-header,
          .accessibility-header {
            flex-direction: column;
            text-align: center;
            gap: 0.5rem;
          }
        }
      `}</style>
    </div>
  );
};

export default FindUs; 